import classNames from "classnames/bind"

export default styles => classNames.bind(styles)
